window.onload = () => {
  const animatedElD = Array.from(
    document.querySelectorAll("section div.column.banner-x2.animated .image-d")
  );
  const animatedElM = Array.from(
    document.querySelectorAll("section div.column.banner-x2.animated .image-m")
  );
  function addClassOnLoad() {
    for (let i = 0; i < animatedElD.length; i++) {
      if (i % 2 === 0) {
        animatedElD[i].classList.add("animated-left");
        animatedElM[i].classList.add("animated-left");
      } else {
        animatedElD[i].classList.add("animated-up");
        animatedElM[i].classList.add("animated-up");
      }
    }
  }
  function pauseAnimation() {
    animatedElD.forEach(function (el) {
      if (el.getBoundingClientRect().top < 0) {
        el.classList.add("animation-paused");
      } else {
        el.classList.remove("animation-paused");
      }
    });
  }
  addClassOnLoad();
  window.addEventListener("scroll", pauseAnimation);
};
